<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Master Bank</h5>
            </template>
            <b-button variant="pgiBtn" class="mr-2 mb-3" name="anggotaEditBtn"  @click="showModalInput"><i class="fa fa-plus"></i> Tambah Bank</b-button>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="bank"
                :currentPage="currentPage" 
                :fields="fields" 
                :perPage="perPage"
                :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
               
                <template v-slot:empty>
                    Tidak ada data bank.
                </template>
                <template v-slot:cell(biaya)="row">
                    {{"Rp. " + row.item.biaya.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                </template>
                <template v-slot:cell(aksi)="row">
                    <div class="no-wrap">
                        <b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Edit"
                            name="jenisBarangHapusBtn" @click="showModalEdit(row.item)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button>
                        <b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Non-Aktif"
                            name="jenisBarangHapusBtn" @click="showModalNonAktif(`${row.item.id}`)">
                            <i class="fa fa-minus-square-o text-danger"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>

              <!-- -----------  MODAL INPUT  ----------- -->
            <b-modal id="modal-tambah-bank" title="Tambah Bank">

                <b-form-group label="Code">
                        <b-form-input
                        v-model="form.code"
                        placeholder="Masukan Code Bank"
                        required
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Nama">
                        <b-form-input
                        v-model="form.name"
                        placeholder="Masukan Nama Bank"
                        required
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Routing Code">
                        <b-form-input
                        v-model="form.routing_code"
                        placeholder="Masukan Routing Code"
                        required
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Biaya" label-for="biaya">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-input-group-text>Rp.</b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="form.biaya" id="biaya" placeholder="Masukan Biaya Admin Bank" required=""></b-form-input>
                        </b-input-group>
                    </b-form-group>


                <template v-slot:modal-footer="{ ok }">
                    <b-button variant="primary" name="submitBtn" @click="confirmSubmit('modal-confirm-input')">
                        Submit
                    </b-button>
                </template>
            </b-modal>

              <!-- -----------  MODAL EDIT  ----------- -->
              <b-modal id="modal-edit-bank" title="Edit Bank">

                <b-form-group label="Code">
                        <b-form-input
                        v-model="form.code"
                        placeholder="Masukan Code Bank"
                        required
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Nama">
                        <b-form-input
                        v-model="form.name"
                        placeholder="Masukan Nama Bank"
                        required
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Routing Code">
                        <b-form-input
                        v-model="form.routing_code"
                        placeholder="Masukan Routing Code"
                        required
                        ></b-form-input>
                </b-form-group>

                <b-form-group label="Biaya" label-for="biaya">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-input-group-text>Rp.</b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="form.biaya" id="biaya" placeholder="Masukan Biaya Admin Bank" required=""></b-form-input>
                        </b-input-group>
                    </b-form-group>


                <template v-slot:modal-footer="{ ok }">
                    <b-button variant="primary" name="submitBtn" @click="confirmEdit('modal-confirm-edit')">
                        Submit
                    </b-button>
                </template>
                </b-modal>

            <ModalConfirm id="modal-confirm-input" title="Confirm Input Bank" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk input Bank ini ?" @submit="onSubmit" />

            <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Bank" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk input Bank ini ?" @submit="onSubmitEdit" />

            <ModalConfirm id="modal-non-aktif-bank" title="Confirm Non Aktif Bank" :isSubmitting="isSubmitting"
            desc="Apakah anda yakin untuk Non Aktif Bank ini?" @submit="nonAktifBank" />

        </b-card>
    </div>
</template>

<script>
import { number } from 'yargs';

export default {
    name: 'master-bank',
    components: {
    },
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,
            activeId: null,

            form : {
                id : null,
                code : null,
                name : null,
                routing_code : null,
                biaya : null
            },

            input: {
                show: 10,
                filterName: null,
                filterNo: null,
                sortBy: null,
                sortDesc: null
            },


            fields: [
                { key: "no", label: "No"},
                { key: "code", label: "Code"},
                { key: "name", label: "Nama Bank"},
                { key: "routing_code", label: "Routing Code"},
                { key: "biaya", label: "Biaya"},
                { key: "aksi", label: "Aksi"},
            ],

            bank:[],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",

        }
    },
  
 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------
    
        init() {

            let getBank = this.$axios.get("bank/list/").then(response => {
                let datas = response.data
                let i = 1
                for(var data of datas){
                    this.bank.push({
                        id:data.id,
                        no : i,
                        code : data.code,
                        name : data.name,
                        routing_code : data.routing_code,
                        biaya : data.biaya,
                    })

                    i++
                }
        
                this.updateTotalItem(response.data.length)
            })

            Promise.all([getBank]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        getBank() {

            let getBank = this.$axios.get("bank/list/").then(response => {
                this.bank = []
                let datas = response.data
                let i = 1
                for(var data of datas){
                    this.bank.push({
                        id:data.id,
                        no : i,
                        code : data.code,
                        name : data.name,
                        routing_code : data.routing_code,
                        biaya : data.biaya,
                    })

                    i++
                }
        
                this.updateTotalItem(response.data.length)
            })

            Promise.all([getBank]).then(() => {
                this.isBusy = false
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        showModalInput(){
            this.form.id = null
            this.form.code = null
            this.form.name = null
            this.form.routing_code = null
            this.form.biaya = null
            this.$bvModal.show("modal-tambah-bank")
        },

        showModalEdit(item){
            this.form.id = item.id
            this.form.code = item.code
            this.form.name = item.name
            this.form.routing_code = item.routing_code
            this.form.biaya = item.biaya
            this.$bvModal.show("modal-edit-bank")
        },

        showModalNonAktif(id){
            this.activeId = id
            this.$bvModal.show("modal-non-aktif-bank")
        },

        confirmSubmit(modalToShow){
            if(this.form.code == null || this.form.code == ""){
                this.$helper.toastErr(this, "Mohon masukan code bank terlebih dahulu!")
                return
            }
            if(this.form.name == null || this.form.name == ""){
                this.$helper.toastErr(this, "Mohon masukan nama bank terlebih dahulu!")
                return
            }
            if(this.form.routing_code == null || this.form.routing_code == ""){
                this.$helper.toastErr(this, "Mohon masukan routing code terlebih dahulu!")
                return
            }
            if(this.form.biaya == null || this.form.biaya == ""){
                this.$helper.toastErr(this, "Mohon masukan biaya bank terlebih dahulu!")
                return
            }
            this.$bvModal.show(modalToShow)
        },

        confirmEdit(modalToShow){
            if(this.form.code == null || this.form.code == ""){
                this.$helper.toastErr(this, "Mohon masukan code bank terlebih dahulu!")
                return
            }
            if(this.form.name == null || this.form.name == ""){
                this.$helper.toastErr(this, "Mohon masukan nama bank terlebih dahulu!")
                return
            }
            if(this.form.routing_code == null || this.form.routing_code == ""){
                this.$helper.toastErr(this, "Mohon masukan routing code terlebih dahulu!")
                return
            }
            if(this.form.biaya == null || this.form.biaya == ""){
                this.$helper.toastErr(this, "Mohon masukan biaya bank terlebih dahulu!")
                return
            }
            this.$bvModal.show(modalToShow)
        },

        onSubmit(){
            let payload = new FormData
            payload.append("code" , this.form.code )
            payload.append("name" , this.form.name )
            payload.append("routing_code" , this.form.routing_code )
            payload.append("biaya" , this.$helper.removeThousandSeparator(this.form.biaya))
            
            this.isSubmitting = true

            this.$axios.post('bank/insertOrUpdateBank', payload, { timeout: 300000 }).then(response => {
              this.$bvModal.hide("modal-tambah-bank")
              this.$bvModal.hide("modal-confirm-input")
              this.$bvModal.hide("modal-edit-bank")
              this.$bvModal.hide("modal-confirm-edit")
              this.form.id = null
              this.form.code = null
              this.form.name = null
              this.form.routing_code = null
              this.form.biaya = null
              this.$helper.toastSucc(this, "Bank Berhasil DiInput!")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
                this.getBank()
            })

        },

        onSubmitEdit(){
            let payload = new FormData
            //-------------- JIKA EDIT ---------------
    
            payload.append("id" , this.form.id )
            payload.append("code" , this.form.code )
            payload.append("name" , this.form.name )
            payload.append("routing_code" , this.form.routing_code )
            payload.append("biaya" , this.$helper.removeThousandSeparator(this.form.biaya))
            
            this.isSubmitting = true

            this.$axios.post('bank/insertOrUpdateBank', payload, { timeout: 300000 }).then(response => {
              this.$bvModal.hide("modal-edit-bank")
              this.$bvModal.hide("modal-confirm-edit")
              this.form.id = null
              this.form.code = null
              this.form.name = null
              this.form.routing_code = null
              this.form.biaya = null
              this.$helper.toastSucc(this, "Bank Berhasil Diedit!")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
                this.getBank()
            })

        },

        nonAktifBank(){
            let payload = new FormData
            payload.append("id" , this.activeId)
            payload.append("isActive" , false)
            this.$axios.post('bank/switch-is-active' , payload ).then(response => {
                this.$bvModal.hide("modal-non-aktif-bank")
                this.getBank()
                this.$helper.toastSucc(this, "Bank berhasil di non aktifkan")
            }).catch(error => {
                console.log(error)
            })
        },


          //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        updateTotalItem(){
            this.perPage = this.input.show
            this.rows = this.bank.length
            if (this.perPage > this.rows){
                this.perPage = this.rows
            }
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

          //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------
    
        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

    
    },

    watch: {
        "form.biaya": function (newValue) {
            if(typeof(newValue) == 'number'){
                newValue = `${newValue}`
            }
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.form.biaya = result);
        },
    },

    created(){
        this.init()
    }
}
</script>
